import { TAX_PAYER_TYPE } from '@/config';
import vatCountries from './vatCountries';

/**
 * Get vat values due relevant billing data (country and account type)
 * @param {object} price
 * @param {object} relevantData
 */
export function getVatValues(
	price,
	{ country, accountType, priceKey = 'baseAmount' } = {}
) {
	let vatValue = 0;
	let vatPercent = 0;

	if (!price[priceKey]) {
		return {
			vatValue,
			vatPercent
		};
	}

	const isFromEU = vatCountries[country];
	const isPrivate = accountType === TAX_PAYER_TYPE.PRIVATE;
	const isSpain = country === 'es';

	if (isSpain || (isFromEU && isPrivate)) {
		vatPercent = vatCountries[country];
		const vatDivider = 1 + vatPercent / 100;

		const priceWithoutVat = price[priceKey] / vatDivider;

		vatValue = Math.round((vatPercent * priceWithoutVat) / 100);
	}

	return {
		vatValue,
		vatPercent
	};
}
